import { HIRING_QUALIFICATION_RANKING } from "@clipboard-health/contract-backend-main";

type Qualification = (typeof HIRING_QUALIFICATION_RANKING)[number];

export const qualificationRanking = HIRING_QUALIFICATION_RANKING;

export function getHighestRankingQualification(qualifications: string[]): string | undefined {
  if (qualifications.length === 0) {
    return undefined;
  }

  return (
    qualificationRanking.find((rankingQualification) =>
      qualifications.includes(rankingQualification)
    ) ?? qualifications[0]
  );
}

export function sortQualificationsByRanking(qualifications: string[]): string[] {
  return [...qualifications].sort(
    (a, b) =>
      qualificationRanking.indexOf(a as Qualification) -
      qualificationRanking.indexOf(b as Qualification)
  );
}
